<template>
	<div>
		<div class="one_01">
			<!-- <div class="one_02" @click="clickBack">
				<i class="el-icon-arrow-left one_03"></i>
				<el-divider direction="vertical"></el-divider>
			</div> -->
			<div class="one_04">
				<el-tabs v-model="activeTabChange" @tab-click="handleTabClick">
					<el-tab-pane v-for="item in tabList" :key="item.key" :label="item.value" :name="item.key">
						<span slot="label" v-if="item.isPush" class="isPush">{{ item.value }}</span>
						<span slot="label" v-else>{{ item.value }}</span>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div class="pd20">
			<slot></slot>
		</div>
	</div>

</template>

<script>
export default {
	name: 'topTab',
	props: {
		activeTab: {
			type: String,
			default: '1'
		},
		tabData: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			tabList: [],
			activeTabChange: this.activeTab
		}
	},
	components: {},
	mounted() {
		this.tabList = this.tabData.filter(item => !item.isHide);
	},
	methods: {
		// 显示
		showTopTab(data) {
			this.tabList = data.filter(item => !item.isHide);
		},
		// tab切换
		handleTabClick() {
			// console.log(this.activeTabChange)
			this.$emit('tabChange', this.activeTabChange)
		},

		// 点击返回
		clickBack() {
			this.$router.go(-1)
		}

	}
}
</script>

<style scoped>
.one_01 {
	width: 100%;
	height: 40px;
	background: #ffffff;
	display: flex;
	align-items: center;
	padding: 0px 20px;
}

.one_02 {
	height: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.one_03 {
	font-size: 18px;
	font-weight: 700;
}

.one_04 {
	height: 100%;
	display: flex;
	align-items: center;
	margin-left: 20px;
	font-size: 12px;
	padding-top: 10px;
}

.isPush {
	padding: 0px !important;
}

.isPush::before {
	content: '';
	width: 0px;
	height: 15px;
	position: absolute;
	top: 12px;
	left: 0px;
	border-left: 2px solid #afabab;
	transform: rotateZ(20deg);
}
</style>